import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import i18n from 'i18next';
import { useMutation } from '@tanstack/react-query';

import { setAppLoader } from '@/redux/common/CommonActions';
import { getShipmentListInProgress, setShipmentFilters, setShipmentList } from '@/redux/Savers/SaversActions';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { generatePartner } from '../data-provider/generate-partner';
import type { GeneratePartnerParams } from '../data-provider/generate-partner/api';

export const useGeneratePartner = () => {
  const dispatch = useDispatch();
  // biome-ignore lint/suspicious/noExplicitAny: TODO: Add types of the state
  const shipmentFilters = useSelector((state: any) => state.savers.shipmentFilters, shallowEqual);
  return useMutation({
    mutationFn: (payload: GeneratePartnerParams) => {
      return generatePartner(payload);
    },

    onError: (error) => {
      showNotification({
        message: error.message || i18n.t('translation:default.fields.somethingWentWrong'),
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onMutate: () => {
      dispatch(setAppLoader(true));
    },
    onSettled: () => {
      dispatch(setAppLoader(false));
    },
    onSuccess: (data, variables) => {
      //TODO: Migrate this from redux to tanstack query
      dispatch(
        setShipmentList({
          data: [],
          isFirstTime: false,
          progressing: true,
          totalRecords: 0,
        }),
      );
      dispatch(setShipmentFilters({ ...shipmentFilters, pageNumber: 1 }));
      dispatch(getShipmentListInProgress());
      const { isInboundTransfer, isOutboundTransfer, isGeneratePayment } = variables;
      showNotification({
        message: isInboundTransfer
          ? 'Inbound transfer generated successfully'
          : isOutboundTransfer
            ? 'Outbound transfer generated successfully'
            : isGeneratePayment
              ? 'Payment generated successfully'
              : 'Received at location updated successfully',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
    },
  });
};
